import {InternalAffairsComplaintVoteResponse} from "../../data/internal-affairs/InternalAffairsComplaintVoteResponse";
import {Stack, Typography} from "@mui/material";
import {InternalAffairsComplaintOutcome} from "../../data/internal-affairs/InternalAffairsComplaintOutcome";
import {RecordTypes} from "../../data/internal-affairs/RecordTypes";

interface InternalAffairsVoterDetailProps {
    data: InternalAffairsComplaintVoteResponse
}

export const InternalAffairsVoterDetail = (props: InternalAffairsVoterDetailProps) => {
    return <Stack direction={"column"} spacing={2}>
        <Stack direction={"row"} spacing={1}>
            <Typography>Outcome - {InternalAffairsComplaintOutcome.get(props.data.outcome ?? "pending")?.displayName}</Typography>
        </Stack>
        {
            props.data.outcome === "sustained" ? <Stack direction={"row"} spacing={1}>
                <Typography>Action Taken - {RecordTypes.get(props.data.actionTaken ?? "Unknown")?.displayName}</Typography>
            </Stack> : <></>
        }
        <Stack direction={"row"} spacing={1}>
            <Typography>Note - {props.data.note ?? "Unknown"}</Typography>
        </Stack>
    </Stack>
}